import loadable from "@loadable/component";

export const Service503 = loadable(() => import("./components/503"));
